
import AppProjectInfo from "@/components/project/ProjectInfo.vue";
import { Project } from "@/models/base";
import { ProjectService } from "@/services/project-service";
import { ToolbarService } from "@/services/toolbar-service";
import Vue from "vue";

export default Vue.extend({
	data() {
		return {
			id: 0,
			project: null as null | Project
		};
	},
	methods: {
		onClose() {
			this.$router.push("/projects");
		},
		onEdit() {
			if (this.project) {
				this.$router.push(`/projects/edit/${this.project.ID}`);
			}
		}
	},
	async created() {
		this.id = parseInt(this.$route.params.id);
		this.project = await ProjectService.get(this.id);
		ToolbarService.title = this.$ct("project-info");
	},
	components: {
		AppProjectInfo
	},
	i18nEx: {
		componentPrefix: "components.project"
	},
	beforeRouteLeave(to, from, next) {
		next();
		this.project = null;
	}
});
